import React from 'react'
import ReactMarkdown from 'react-markdown'
import { ChatMessage } from '../types/llm'

interface MessageListProps {
  messages: ChatMessage[]
}

const MessageList: React.FC<MessageListProps> = ({ messages }) => {
  return (
    <div className="mx-auto max-w-3xl space-y-4">
      {messages.map((message) => (
        <div
          key={message.id}
          className={`chat-message flex ${
            message.role === 'user' ? 'justify-end' : 'justify-start'
          }`}
        >
          <div
            className={`max-w-[80%] rounded-lg px-4 py-3 ${
              message.role === 'user'
                ? 'bg-primary-600 text-white'
                : message.error
                ? 'bg-red-100 dark:bg-red-900/20 text-red-700 dark:text-red-400'
                : 'bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 border border-gray-200 dark:border-gray-700'
            }`}
          >
            {message.role === 'assistant' ? (
              <div className="prose prose-sm dark:prose-invert max-w-none">
                <ReactMarkdown>{message.content}</ReactMarkdown>
              </div>
            ) : (
              <p className="whitespace-pre-wrap">{message.content}</p>
            )}
            <div className={`mt-2 text-xs ${
              message.role === 'user' 
                ? 'text-primary-200' 
                : 'text-gray-500 dark:text-gray-400'
            }`}>
              {message.timestamp.toLocaleTimeString()}
              {message.model && ` • ${message.model}`}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default MessageList
